import { analyticsUrl } from 'utils/wrappers';

import BaseCollection from 'app/collections/base';
import TrackingStatusReport from 'app/models/tracking_status_report';

export default BaseCollection.extend({
  model: TrackingStatusReport,
  key: 'status_report',
  url: analyticsUrl('tracking/v2/trackers/status_report'),

  initialize(models, { dateRange, carrierSelection, servicePrioritySelection }) {
    this.dateRange = dateRange;
    this.carrierSelection = carrierSelection;
    this.servicePrioritySelection = servicePrioritySelection;

    this.listenTo(this.dateRange, 'change', this.fetchWithReset);
    this.listenTo(this.carrierSelection, 'change', this.fetchWithReset);
    this.listenTo(this.servicePrioritySelection, 'change', this.fetchWithReset);
  },

  paramsForFetch() {
    return {
      ...this.dateRange.getParams(),
      ...this.carrierSelection.getParams(),
      ...this.servicePrioritySelection.getParams(),
    };
  },

  fetchWithReset() {
    this.fetch({ reset: true });
  }
});



// WEBPACK FOOTER //
// ./app/collections/tracking_status_reports.js